import React, { Component, Fragment } from 'react';
import { MeetingNotesServices , UtilityService} from "../../services";
import Moment from 'react-moment';
import productPic from '../../assets/images/no-product-image.png';
import AlertContainer from 'react-alert';
import PageHeader from '../../components/Page/PageHeader/PageHeader'
class GenerateTag extends Component {
    constructor(props) {
        super(props);
        this.state = {
            meetingNotes: [],
            meetingNoteContent: '',
            searchMeetingNotesBy: ''
        }

    }
    alertOptions = {
        offset: 65,
        position: 'top left',
        theme: 'dark',
        time: 1000,
        transition: 'scale'
    }
    componentWillMount() {
        MeetingNotesServices.listMeetingNotes().then((response) => {
            if (response.message === "List Displayed") {
                
                this.setState({ meetingNotes: response.data })
            }
        }).catch((error) => {
           UtilityService.errorMsg(this.msg)
        })
    }

    cloneMeeting(id) {
        MeetingNotesServices.cloneMeeting(id).then((response) => {
            if (response.message === "Meeting Note cloned") {
                MeetingNotesServices.listMeetingNotes().then((response) => {
                    if (response.message === "List Displayed") {
                        
                        this.setState({ meetingNotes: response.data })
                    }
                }).catch((error) => {
                   UtilityService.errorMsg(this.msg)
                })
            }
        }).catch((error) => {
           UtilityService.errorMsg(this.msg)
        })
    }

    removeMeeting(id) {
        MeetingNotesServices.removeMeeting(id).then((response) => {
            if (response.message === "Meeting Note successfully deleted") {
                MeetingNotesServices.listMeetingNotes().then((response) => {
                    if (response.message === "List Displayed") {
                        
                        this.setState({ meetingNotes: response.data })
                    }
                }).catch((error) => {
                   UtilityService.errorMsg(this.msg)
                })
            }
        }).catch((error) => {
           UtilityService.errorMsg(this.msg)
        })
    }

    searchMeetingNotes() {


        MeetingNotesServices.searchMeetingNotesBy(this.state.searchMeetingNotesBy, this.state.meetingNoteContent).then((response) => {
            if (response.message === "List Displayed") {
                this.setState({ meetingNotes: response.data })
            }
        }).catch((error) => {
           UtilityService.errorMsg(this.msg)
        })


    }

    addMeetingContent(e) {
        this.setState({ meetingNoteContent: e.target.value }, function () {
            if (this.state.meetingNoteContent.length === 0) {
                MeetingNotesServices.listMeetingNotes().then((response) => {
                    if (response.message === "List Displayed") {
                        
                        this.setState({ meetingNotes: response.data })
                    }
                }).catch((error) => {
                   UtilityService.errorMsg(this.msg)
                })

            }
        })
    }

    render() {
        return (
            <Fragment>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
                
                    <div class="right-section">
                        <div class="row nopadding">
                        <PageHeader header="Tag"/>
                                    <div class="col-md-12 nopadding">
                                        {/* <!-- First Section Starts here --> */}
                                        <div class="card-container  meeting-min-con">
                                            <div class="table-container">
                                                <div class="row" style={{paddingBottom:"2%"}}>
                                                    <div class="col-md-12 product-form no-padding">
                                                        <div class="col-md-12 no-padding">
                                                            <div class="col-md-12 no-padding">
                                                                <h6 class="dev-title" style={{paddingLeft:"15px", paddingBottom:"10px"}}><b>Tag</b></h6>
                                                            </div>
                                                            <div class="col-md-12 no-padding">
                                                                <div class="col-md-2">
                                                                    <div class="upload-photo">
                                                                        <img src={productPic} alt="" />
                                                                        {/* <!-- <a class="btn-floating btn-small waves-effect waves-light black"><i class="material-icons">add</i></a> --> */}
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="">Customer Ref No.</label>
                                                                        <input type="number" min="0" class="form-control" name="" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="">Magnum Ref No.</label>
                                                                        <input type="number" min="0" class="form-control" name="" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-4 step-one">
                                                                    <div class="form-group">
                                                                        <label for="">Style Description</label>
                                                                        <input type="text" class="form-control" name="" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="">Fabric</label>
                                                                        <input type="text" class="form-control" name="" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="ref-no">Wash Type</label>
                                                                        <select class="form-control" name="">
                                                                            <option value="style">Select</option>
                                                                            <option value="style">Soft Wash </option>
                                                                            <option value="style">Acid Wash </option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-1 step-one">
                                                                    <div class="form-group">
                                                                        <label for="">Size</label>
                                                                        <input type="number" min="0" class="form-control" name="" value="" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="">Sample Type</label>
                                                                        <select class="form-control" name="">
                                                                            <option value="style">Select</option>
                                                                            <option value="style">Soft Wash </option>
                                                                            <option value="style">Acid Wash </option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="">Date</label>
                                                                        <input type="date" class="form-control" name="" value="" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12 no-padding text-center profile-btn">
                                                            <button type="button" class="primary" name="button">Back</button> <button type="button" class="primary" name="button">Complete</button> <button type="button" class="primary" name="button">Edit</button> <button type="button" class="primary" name="button">print</button> <button type="button" class="primary" name="button">Cancel</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                

            </Fragment>
        );
    }
}

export default GenerateTag;












// WEBPACK FOOTER //
// ./src/pages/generateTag/page.js